import { SubscriptionPlanEntity } from '@/app/entities/subcription.plan.entity';
import SubscriptionPlansRepository from '@/app/repository/subscriptionPlans.repository';

export default {
  async getPlans() {
    const plans = await SubscriptionPlansRepository.getSubscriptionPlans();
    return plans.map(p => new SubscriptionPlanEntity(p));
  }
};
